import {Component, Inject, OnInit} from '@angular/core';
import {ToasterService} from "../../../../../../../services/core/toaster.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {BackendApiService} from "../../../../../../../services/backend-api.service";

@Component({
    selector: 'app-quick-subcontractor',
    templateUrl: './quick-subcontractor.component.html',
    styleUrls: ['./quick-subcontractor.component.scss'],
    standalone: false
})
export class QuickSubcontractorComponent implements OnInit {
  public sectionForm!: UntypedFormGroup;
  constructor(
    public toasterService: ToasterService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<QuickSubcontractorComponent>,
    public backendApiService:BackendApiService,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }
  initForm(){
    this.sectionForm = new UntypedFormGroup({
      name: new UntypedFormControl('' , [Validators.required]),
    });
  }

  getFormData() {
    const form = this.sectionForm?.value;
    return {
      name: form?.name,
    }
  }

  onConfirm = () => {
    if (this.sectionForm.invalid) {
      this.touchFormControls();
      return
    }
    this.backendApiService.postApi('subcontractors/quick-create', this.getFormData())
      .subscribe((response: any) => {
        if(response) {
          console.log('response',response);
          this.close(response?.data?.data);
        }
      })
  }
  touchFormControls(){
    Object.keys(this.sectionForm.controls).forEach(key => {
      this.sectionForm.get(key)?.markAsTouched();
    });
  }
  close = (data: any = null) => {
    this.dialogRef.close(data);
  }

}
